import { useStore } from "@/provider/store";

/** Tabs come from the store, which derives them from the server's dashboard
 *  (metric-category) list — see `availableTabs`. */
export function PillarTabs({ pillar, setPillar }: { pillar: string; setPillar: (p: string) => void }) {
  const s = useStore();
  return (
    <div className="pilltabs"><div className="pilltabs-inner">
      {s.tabs.map((t) => <button key={t.key} className={"pilltab" + (pillar === t.key ? " on" : "")} onClick={() => setPillar(t.key)}>{t.label}</button>)}
    </div></div>
  );
}
